import { Injectable, Injector, NgZone, effect, inject, signal } from '@angular/core';

import { MessageService } from 'primeng/api';

import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusService {
  isMonitoringStarted = false;
  isOffline = signal<boolean>(typeof navigator !== 'undefined' ? !navigator.onLine : false);

  private readonly zone = inject(NgZone);
  private readonly injector = inject(Injector);
  private readonly messageService = inject(MessageService);

  private isOnlineMessage: string = '';
  private isOfflineMessage: string = '';

  constructor() {
    effect(() => {
      const translationService = this.injector.get(TranslationService);
      this.isOnlineMessage = translationService.getLabelValue('COMMON.ONLINE_MESSAGE');
      this.isOfflineMessage = translationService.getLabelValue('COMMON.OFFLINE_MESSAGE');
    });
  }

  startMonitoring(): void {
    if (this.isMonitoringStarted || typeof window === 'undefined') {
      return;
    }

    this.isMonitoringStarted = true;
    this.isOffline.set(!navigator.onLine);

    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
  }

  stopMonitoring(): void {
    if (this.isMonitoringStarted) {
      this.isMonitoringStarted = false;

      window.removeEventListener('online', this.handleOnline);
      window.removeEventListener('offline', this.handleOffline);
    }
  }

  private handleOnline = (): void => {
    if (!this.isMonitoringStarted) {
      return;
    }

    this.zone.run(() => {
      this.isOffline.set(false);
      this.messageService.add({ severity: 'success', detail: this.isOnlineMessage, life: 3500 });
    });
  };

  private handleOffline = (): void => {
    if (!this.isMonitoringStarted) {
      return;
    }

    this.zone.run(() => {
      this.isOffline.set(true);
      this.messageService.add({ severity: 'warn', detail: this.isOfflineMessage, life: 5000 });
    });
  };
}
